import React from 'react';
import classNames from 'classnames';
import './styles.scss';

interface Props {
  label: string;
  menuId: string;
  selectable?: boolean;
  selectedMenuId?: string;
  onSelect(id: string): void;
}

const CampaignsModalMenuItem: React.FC<Props> = ({
  label,
  menuId,
  selectable = true,
  selectedMenuId = null,
  onSelect
}) => {
  const itemClasses = classNames({
    'modal-menu-item': true,
    'not-selectable': !selectable,
    selected: menuId === selectedMenuId
  });
  return (
    <div className={itemClasses} onClick={selectable ? () => onSelect(menuId) : null}>
      <div>{label}</div>
    </div>
  );
};

export default CampaignsModalMenuItem;
